import { Injectable } from '@angular/core';
import { GeoPoint } from '@core/const';
import { DELIVERY_FEATURE_LAZY, DeliverySlot, DeliverySlotGroupByDate } from '@delivery/const';
import { StateUtils, facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: DeliverySlotsService,
      feature: DELIVERY_FEATURE_LAZY,
      methods: [
        'getDeliverySlots',
        'getDeliverySlotsGroupByDate',
        'getDeliverySlotsLoading',
        'getDeliverySlotsState',
        'loadDeliverySlots',
      ],
      async: true,
    }),
})
export abstract class DeliverySlotsService {
  abstract getDeliverySlots(): Observable<DeliverySlot[]>;

  abstract getDeliverySlotsGroupByDate(): Observable<DeliverySlotGroupByDate[]>;

  abstract getDeliverySlotsLoading(): Observable<boolean>;

  abstract getDeliverySlotsState(): Observable<StateUtils.LoaderState<DeliverySlot[]>>;

  abstract loadDeliverySlots(geoPoint: GeoPoint, weight: number): void;
}
